exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-login {\n  background: #f6f8fa;\n  border: solid 1px #ecf0f4;\n  padding: 30px 20px 75px 20px;\n  margin-top: 100px;\n}\n\n.form-login h5 {\n  color: #292c31;\n  margin-bottom: 30px;\n  font-size: 21px;\n  font-weight: normal;\n}\n\n.form-login .btn-primary {\n  margin-bottom: 22px;\n  margin-top: 10px;\n  padding-right: 40px;\n  padding-left: 40px;\n  float: right;\n}\n\n.form-login .invalid-feedback {\n  display: block !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /app/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/app/node_modules/postcss-loader?{"ident":"postcss"}!/app/src/styles/admin/login.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles/admin/login.css
// module chunks = styles